<template>
  <nav class="navbar is-primary bookman-gradient" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <div class="navbar-item has-text-weight-semibold app-title" @click="goToMainPage()">
          Bookman
        </div>
        <div class="navbar-burger burger" v-bind:class="{ 'is-active': isBurgerActive }"  @click="toggleBurgerActive()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="navbar-menu" v-bind:class="{ 'is-active': isBurgerActive }">
        <!--
        <div class="navbar-start">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              Lists
            </a>
            <div class="navbar-dropdown is-boxed">
              <a class="navbar-item" v-for="list in getNavBarLists" :href="getListLink(list)" :key="list.id">
                <span>
                  {{ list.name }}
                </span>
              </a>
            </div>
          </div>
          <a class="navbar-item" href="/#/discover">
              Discover
          </a>
        </div> -->
        <div class="navbar-end">
          <div class="navbar-item" >
            <a class="button is-secondary" v-if="isAuthenticated" @click="goToSubscription">Subscribe!</a>
          </div>
          <div class="navbar-end" v-if="isAuthenticated">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link" href="/#/profile" v-if="!isBurgerActive">
                🤓
              </a>
              <div class="navbar-dropdown is-boxed is-right">
                <a class="navbar-item" href="/#/profile">
                  <span>
                    Profile
                  </span>
                </a>
                <hr class="navbar-divider">
                <a class="navbar-item" @click="userSignOut">
                  <div class="navbar-item-content">
                    <span class="icon">
                      <i class="mdi mdi-logout"></i>
                    </span>
                    <span>
                      Sign Out
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="navbar-end" v-else>
            <a class="navbar-item" href="/#/signup">
              Sign Up
            </a>
            <a class="navbar-item" href="/#/signin">
              Sign In
            </a>
          </div>
        </div>
      </div>
    </nav>
</template>

<script>
export default {
  data () {
    return {
      isBurgerActive: false
    }
  },
  created () {
    this.$store.dispatch('loadLists', {
      limit: 5
    })
  },
  methods: {
    getListLink (list) {
      if (list) {
        return `/#/lists/${list.uriParam}`
      }
      return ''
    },
    goToSubscription () {
      this.$router.push('/subscription')
    },
    goToMainPage () {
      this.$router.push('/')
    },
    toggleBurgerActive () {
      this.isBurgerActive = !this.isBurgerActive
    },
    userSignOut () {
      this.$store.dispatch('userSignOut')
    }
  },
  computed: {
    getNavBarLists () {
      return this.$store.getters.getNavBarLists
    },
    getUserTicketsCount () {
      return this.$store.getters.getUserTicketsCount
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>

<style>
  .app-title {
    cursor: pointer;
  }

  .navbar-item-content {
    position: relative;
  }

  .bookman-gradient {
    background-image: radial-gradient( circle farthest-corner at 12.3% 19.3%,  rgba(85,88,218,1) 0%, rgba(95,209,249,1) 100.2% );
  }
</style>
